export const StorageSetItemAdapter = (key, json) => {
	const location = localStorage.getItem(key);
	if (location !== undefined) {
		return;
	}
	localStorage.setItem(key, JSON.stringify(json));
};
